import {Nullish} from 'shared/web';

import {VehicleAudit} from '../api/digitalCertificateApi';
import {isCarvagoWorkspace} from './isCarvagoWorkspace';

/**
 * The equipment PDF the certificate offers for download: the inspection's attachment in the
 * Carvago workspace, nothing elsewhere.
 */
export function getCertificateEquipmentDocument(
  vehicleAudit: Pick<VehicleAudit, 'equipmentDocument'> | Nullish
) {
  if (!isCarvagoWorkspace()) {
    return null;
  }

  return vehicleAudit?.equipmentDocument ?? null;
}
